import React from 'react';
import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    heading: 'Product',
    links: [
      { label: 'Features', href: '/#features' },
      { label: 'How it works', href: '/#how-it-works' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Sign in', href: '/login' },
    ],
  },
  {
    heading: 'Platform',
    links: [
      { label: 'Skill registry & governance', href: '/#features' },
      { label: 'Agent routing', href: '/#features' },
      { label: 'Integrations', href: '/#features' },
      { label: 'Approvals & audit', href: '/#features' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '/#' },
      { label: 'Contact sales', href: '/pricing#contact' },
      { label: 'Status', href: '/#' },
    ],
  },
];

export default function PublicFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="lp-footer">
      <div className="lp-footer__top">
        <div className="lp-footer__brand">
          <span className="lp-nav__mark">ECS</span>
          <p>
            The control plane for governing Claude skills — route, approve, execute,
            and deliver into the tools your teams already use.
          </p>
        </div>
        <div className="lp-footer__columns">
          {COLUMNS.map((col) => (
            <div className="lp-footer__col" key={col.heading}>
              <h4>{col.heading}</h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.href.startsWith('/') && !l.href.includes('#') ? (
                      <Link to={l.href}>{l.label}</Link>
                    ) : (
                      <a href={l.href}>{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="lp-footer__bottom">
        <span>© {year} Enterprise Claude Skills Platform</span>
        <span>MVP build — pricing shown is indicative demo pricing.</span>
      </div>
    </footer>
  );
}
